(function (app, $) {
    $(document).ready(function () {
        if ($('.page_film').length > 0) {
            var showChar = 300;  // How many characters are shown by default
            var ellipsestext = "...";
            var moretext = app.resources.readmore;
            var lesstext = app.resources.readless;

            $('#toggle_more_screenings').on('click', function () {
                $('#svg_arrow').toggleClass('rotate');
            });

            $('.more').each(function () {
                var content = $(this).html();

                if (content.length > showChar) {

                    var c = content.substr(0, showChar);
                    var h = content.substr(showChar, content.length - showChar);

                    var html = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

                    $(this).html(html);
                }
            });
            $(".morelink").on('click', function () {
                if ($(this).hasClass("less")) {
                    $(this).removeClass("less");
                    $(this).html(moretext);
                } else {
                    $(this).addClass("less");
                    $(this).html(lesstext);
                }
                $(this).parent().prev().toggle();
                $(this).prev().toggle();
                return false;
            });

            $('#search_films').on('keyup', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    $('#search_films_btn').trigger('click');
                }
            });
            $('#search_films_btn').on('click', function (e) {
                e.preventDefault();
                if ($('#search_films').val().length > 2 || $('#search_films').val().length == 0) {
                    $.post(app.routes.home.searchFilms, { query: $('#search_films').val() })
                        .done(function () {
                            window.location = app.routes.home.index;
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                }

                return false;
            });

            $('.watch-later-btn').on('click', function () {
                var $this = $(this);
                $.post(app.routes.film.watchLater, { filmId: $('#film_id').val(), isWatchLater: !$this.hasClass('selected') })
                    .done(function () {
                        $this.toggleClass('selected');
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Watch-later update error', status, error);
                    });
            });

            $('.favorite-btn').on('click', function () {
                var $this = $(this);
                $.post(app.routes.film.favorite, { filmId: $('#film_id').val(), isFavorite: !$this.hasClass('favorite') })
                    .done(function () {
                        $this.toggleClass('favorite');
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Fav update error', status, error);
                    });
            });

            $('#player_launcher').on('click', function () {
                $(this).addClass('d-none');
                $.get(app.routes.film.player, { id: $('#film_id').val() })
                    .done(function (data) {
                        $('#player_frame').html(data);
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Player loading error', status, error);
                    });
            });

            $('#save_note_btn').on('click', function (e) {
                e.preventDefault();
                $.post(app.routes.film.note, { filmId: $('#film_id').val(), text: $('#noteText').val() })
                    .done(function () {
                        
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Note update error', status, error);
                    });

                return false;
            });

            // Trailers
            $('#modal_trailer')
                .on('shown.bs.modal', function () {
                    var $this = $(this);
                    var $video = $(this).find('video');

                    if ($video.length > 0 && $this.find('.trailer-list').length === 0) {
                        //start playing video
                        $video.get(0).play();
                    }
                })
                .on('hide.bs.modal', function () {
                    var $this = $(this);
                    var $video = $this.find('video');

                    if ($video.length > 0) {
                        //stop playing video
                        $video.get(0).pause();
                    }
                });

            $('.trailer-list')
                .on('click', '.trailer-item:not(.selected)', function () {
                    var $this = $(this);
                    $this.siblings().removeClass('selected');
                    $this.addClass('selected');

                    $video = $this.closest('.modal-dialog').find('video');
                    if ($video.length > 0) {
                        var video = $video.get(0);
                        //switching video
                        video.pause();
                        video.src = $this.data('trailer-item');
                        video.play();
                        //video.oncanplay = function () {
                        //    video.play();
                        //};
                        //video.load();
                    }
                });

            //Pictures
            //initialize swiper ( Slider accueil )
            if ($('.swiper-container .swiper-slide').length > 1) {
                var swiper = new Swiper('.swiper-container', {
                    slidesPerView: 1,
                    // Responsive breakpoints
                    breakpoints: {
                        // when window width is >= 480px
                        1200: {
                            slidesPerView: 3
                        }
                    },
                    loop: true,
                    autoplay: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                });
            }

            $('.mail-contact').on('click', function () {
                $('.contact-item').removeClass('d-none');
                $('.shift-item').addClass('d-none');
                $('#contact_modal .form-submit').data('form-target', '#form_contact');

                $('#contact_modal').modal('show');
            });

            $('.shift-contact').on('click', function () {
                $('.contact-item').addClass('d-none');
                $('.shift-item').removeClass('d-none');
                $('#contact_modal .form-submit').data('form-target', '#form_shift');

                $('#contact_modal').modal('show');
            });

            $('.zoomable').on('click', function () {
                $this = $(this);

                var $swiper = $this.closest('.swiper-container');
                //if ($swiper.length > 0) {
                //    $swiper.get(0).swiper.autoplay.stop();
                //}

                var $template = $('<div id="zoom" class="zoom-popup"><div class="zoom-container"><span class="zoom-close clickable"><i class="fas fa-times"></i></span></div></div>');
                var $img = $this.clone();
                $img.addClass('zoom-img');
                $template.find('.zoom-container').append($img);
                $('body').append($template);

                $template.find('.zoom-close').on('click', function () {
                    //if ($swiper.length > 0) {
                    //    $swiper.get(0).swiper.autoplay.start();
                    //}
                    $template.remove();
                });
            });
        }
    });
})(window.app = window.app || {}, jQuery);